import React from 'react'
import { Flex, Box, Text } from 'rebass/styled-components'
import styled, { keyframes } from 'styled-components'
const items = [
  'Atlatl',
  'AutoNation',
  'Avoxi',
  'Ceterus',
  'Charleston FabLab',
  'Chocolate and Carrots',
  'Columbia Development',
  // 'Creative Labs',
  'Drivewyze',
  'Edyn',
  'Greystar',
  'Heatworks',
  'Hinge',
  "Lauren's Latest",
  'Loop',
  'Moovila',
  'Medical University of South Carolina',
  'Podfly',
  'Radtab',
  'Rhinogram',
  'SoleSavy',
  'StagePilot',
  'Stre.am',
  // 'Tabula Rasa Healthcare',
  'Versett',
  'WeeFarers',
  'Zubtitle',
]

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const FadeText = styled(Text)`
  animation-name: ${fadeIn};
  animation-fill-mode: backwards;
`

const PartnerList = () => {
  return (
    <Flex
      justifyContent='center'
      alignItems='center'
      flexWrap='wrap'
      width={[1, 1 / 2]}
      margin='auto'
    >
      {items.sort().map((item) => (
        <Box key={item} p={[2, 3]}>
          <FadeText
            color='primary'
            fontFamily='serif'
            fontSize={[2, 3]}
            sx={{
              animationDuration: '2000ms',
              animationDelay: `${Math.random() * 1200}ms`,
            }}
          >
            {item}
          </FadeText>
        </Box>
      ))}
    </Flex>
  )
}

export default PartnerList
